import kioskLaunchModalUrl from '../../kiosk/kiosk-launch-modal.html';
import config from '../../config';

import timesheetsSubNavComponentUrl from './timesheetsSubNavComponent.html';

class TimesheetsSubNavCtrl {
  HEADLESS_BATCH_PRINT_URL = config.HEADLESS_BATCH_PRINT_URL;

  constructor(Authentication, KioskService, $uibModal) {
    'ngInject';

    Object.assign(this, { Authentication, KioskService, $uibModal });
  }

  tabs = [{ value: 'timesheets', label: 'timesheets' }];
  activeTab = this.tabs[0].value;

  changeTab() {
    // to be implemented when more tabs are added
  }

  canLaunchTimeClockKiosk() {
    const { org, orgSettings } = this.Authentication.user;
    return (
      org.isPremium &&
      orgSettings.clockInEnabled &&
      orgSettings.clockInFromKiosk &&
      this.user.isManager
    );
  }

  async launchTimeClockKiosk() {
    const modalInstance = this.$uibModal.open({
      size: '620',
      templateUrl: kioskLaunchModalUrl,
    });

    try {
      await modalInstance.result;
      const _sendRequest = this.Authentication.sendRequest.bind(this.Authentication);
      const guid = await this.KioskService.initializeKiosk(
        _sendRequest,
        this.Authentication.httpConfig
      );
      if (guid) {
        this.KioskService.redirectToKiosk(guid, this.Authentication.user.settings.usTimeFormat);
        this.Authentication.logout(true, false, true);
      }
    } catch (e) {
      // user cancelled
    }
  }
}

export default {
  bindings: {
    user: '<',
    showDurationsAsDecimals: '=',
    changedShowDurationsAsDecimals: '<',
    getDataForExport: '&',
    getPrintPayload: '&',
    exportFileName: '@',
    printForAllEmployees: '&',
  },
  templateUrl: timesheetsSubNavComponentUrl,
  controllerAs: 'ctrl',
  controller: TimesheetsSubNavCtrl,
};
